import { useEffect, useRef } from 'react'
import { useInboundNotifications } from '../context/inbound-notifications-context'
import { InboundSmsEventBadge } from './inbound-sms-event-badge'

type Props = {
  eventId: string
  previewFromEvent?: string
}

export function InboundSmsEventBadgeConnected({ eventId, previewFromEvent }: Props) {
  const { getPreviewForEvent, handleEventBadgeOpen, refreshNotifications } = useInboundNotifications()
  const preview = previewFromEvent ?? getPreviewForEvent(eventId)
  const previewRequestEventIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (preview) {
      previewRequestEventIdRef.current = null
      return
    }

    if (previewRequestEventIdRef.current === eventId) {
      return
    }

    previewRequestEventIdRef.current = eventId
    void refreshNotifications()
  }, [eventId, preview, refreshNotifications])

  return <InboundSmsEventBadge eventId={eventId} preview={preview} onOpenCenter={handleEventBadgeOpen} />
}
